import { DateTime } from 'luxon';

import { WeeklyWorkLog } from '@/types';
import { YLog } from '@/types/yandex';

import { parseDuration } from './parseDuration';

export function transformYLogToWeeklyWorkLog(log: YLog): WeeklyWorkLog {
  const logDate = DateTime.fromISO(log.start).toISODate()!;
  const durationMinutes = parseDuration(log.duration);
  const taskKey = log.issue?.key || 'UNKNOWN';
  const taskTitle = log.issue?.display || 'Неизвестная задача';

  return {
    id: String(log.id),
    taskKey,
    taskTitle,
    duration: log.duration,
    durationMinutes,
    comment: log.comment,
    date: logDate,
    createdAt: log.createdAt,
    start: log.start,
  };
}
